import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BadgesComponent from '@components/common/Badges';
import Button from '@components/common/Button';
import './HealthFacilityOverview.css';
import CoverageCardViewComponent from '@components/common/CoverageCardView';
import dayjs from 'dayjs';
import { buttonNames } from '@constants/appConstants';
import { useDispatch, useSelector } from 'react-redux';
import { setApprovalPageType } from '@store/actions/approvalActions';
import { approvalConstantData, approvalsRoleCode, checkUserRole, errorSuccessMessage, pageType, roleType, STATUS } from '@constants/approvalConstants';
import FacilityESRIMap from '@components/common/Esrimap/FacilityESRIMap';
import { page_type } from '@constants/esriMapConstant';
import config from '@config/config';
import ApprovalModal from '../approvalModal';
import { RootState } from '@store/reducers';
import { approvalStatusUpdate } from '@services/approvalApiServices';
import { toast } from 'react-toastify';
import { PagePermission } from '@services/usePermission';
import { ruralUrban } from '../Update/HealthFacilityUpdateConstant';
import { decodeWithKeyAndShift } from '@utils/base64Utils';

interface propType {
  facility: any;
}

const HealthFacilityOverview = (props: propType) => {
  const { facility } = props;
  const [selectedView, setSelectedView] = useState(pageType.currentPage);
  const [showApprovalModal, setShowApprovalModal] = useState<boolean>(false);
  const approvalLayout = useSelector((state: RootState) => state.approvalWorkFlow);
  const resubmitEnable = PagePermission(approvalsRoleCode.module_code, approvalsRoleCode.pageCode.Approvals_Resubmit)
  const editApproveEnable = PagePermission(approvalsRoleCode.module_code, approvalsRoleCode.pageCode.Approvals_EDPg)
  const rejectEnable = PagePermission(approvalsRoleCode.module_code, approvalsRoleCode.pageCode.Approvals_Reject)
  const encodedUserRoles = localStorage.getItem('userRoleDetails');
  const userRolesDetails = encodedUserRoles ? JSON.parse(decodeWithKeyAndShift(encodedUserRoles)).split(', ') : [];
  const roleData = checkUserRole(userRolesDetails)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [facilityDetails, setFacilityDetails] = useState<any>({});
  const [locationDetails, setLocationDetails] = useState<any>({});
  const [abdmData, setAbdmData] = useState<any>({});

  const stripLinkedPrefix = (item: any) =>
    Object.fromEntries(
      Object.entries(item).map(([k, v]) => [
        k.startsWith('linked_') ? k.replace('linked_', '') : k,
        v,
      ]),
    );

  useEffect(() => {
    const currentHealthFacility =
      selectedView === pageType.previousPage
        ? facility[0]?.previous_data?.[0]
        : facility[0]?.current_data?.[0];

    if (!currentHealthFacility?.facility_info?.location_details) {
      return;
    }

    if (selectedView !== pageType.previousPage) {
      currentHealthFacility.facility_info.location_details.linked_ward = (
        currentHealthFacility.facility_info.location_details.linked_ward || []
      ).map(stripLinkedPrefix);
      currentHealthFacility.facility_info.location_details.linked_facility_details =
        (
          currentHealthFacility.facility_info.location_details
            .linked_facility_details || []
        ).map(stripLinkedPrefix);
      currentHealthFacility.facility_info.location_details.linked_village = (
        currentHealthFacility.facility_info.location_details.linked_village ||
        []
      ).map(stripLinkedPrefix);
      currentHealthFacility.facility_info.location_details.linked_gram_panchayat =
        (
          currentHealthFacility.facility_info.location_details
            .linked_gram_panchayat || []
        ).map(stripLinkedPrefix);
      setFacilityDetails(
        currentHealthFacility?.facility_info?.facility_details?.[0],
      );
      setLocationDetails(
        currentHealthFacility?.facility_info?.location_details,
      );
      setAbdmData(currentHealthFacility?.facility_info?.abdm_info?.[0]);
    } else {
      setFacilityDetails(
        currentHealthFacility?.facility_info?.facility_details,
      );
      setAbdmData(currentHealthFacility?.facility_info?.abdm_info?.[0]);
      currentHealthFacility.facility_info.location_details.category_details =
        currentHealthFacility?.facility_info?.category_details;
      currentHealthFacility.facility_info.location_details.linked_ward =
        currentHealthFacility?.facility_info?.linked_ward_details;
      currentHealthFacility.facility_info.location_details.linked_village =
        currentHealthFacility?.facility_info?.linked_village_coverage;
      currentHealthFacility.facility_info.location_details.linked_gram_panchayat =
        currentHealthFacility?.facility_info?.linked_gram_panchayat_id;
      currentHealthFacility.facility_info.location_details.linked_ward = (
        currentHealthFacility?.facility_info?.location_details.linked_ward || []
      ).map(stripLinkedPrefix);
      currentHealthFacility.facility_info.location_details.linked_facility_details =
        (
          currentHealthFacility?.facility_info?.location_details
            .linked_facility_details || []
        ).map(stripLinkedPrefix);
      currentHealthFacility.facility_info.location_details.linked_village = (
        currentHealthFacility?.facility_info?.location_details.linked_village ||
        []
      ).map(stripLinkedPrefix);
      currentHealthFacility.facility_info.location_details.linked_gram_panchayat =
        (
          currentHealthFacility?.facility_info?.location_details
            .linked_gram_panchayat || []
        ).map(stripLinkedPrefix);
      setLocationDetails(
        currentHealthFacility?.facility_info?.location_details,
      );
    }
  }, [selectedView, facility]);

  const joinCategoryNames = (items: any[]): string =>
    !Array.isArray(items) || items.length === 0
      ? '-'
      : [...new Set(items.map(i => i?.category_name).filter(Boolean))].join(', ');

  const handleReject = async () => {
    let statusChangedId = ''
    if (approvalLayout.requestData.requestFor == approvalConstantData.requestFor.received) {
      const rejectedData = approvalLayout.approvalStatus.length > 0 ? approvalLayout.approvalStatus.filter((ele: any) => ele.code == STATUS.REJECTED) : [];
      statusChangedId = rejectedData.length > 0 ? rejectedData[0].id : ''
    }
    const reducerData = approvalLayout.requestData;
    const comments = approvalLayout.comments;
    const res = await approvalStatusUpdate(reducerData, comments, null, statusChangedId, false,facilityDetails?.facility_name,dayjs(facility[0]?.effective_from_date).format('YYYY-MM-DD'), 'REJECTED');
    if (res) {
      setShowApprovalModal(false)
      toast.success(errorSuccessMessage.rejectSuccess, {
        position: 'top-center',
      });
      navigate(`/approvals-flow`);
    }
  }


  return (
    <div>
      <div className="health-facility-overview-container">
        <div className="health-facility-tabs-container">
          {facility[0]?.previous_data && <div
            onClick={() => setSelectedView(pageType.previousPage)}
            className={`health-facility-tab ${selectedView === pageType.previousPage ? 'active' : 'inactive'}`}
          >
            Previous Details
          </div>}
          <div
            onClick={() => setSelectedView(pageType.currentPage)}
            className={`health-facility-tab ${selectedView === pageType.currentPage ? 'active' : 'inactive'}`}
          >
            Current Details
          </div>
        </div>
        {selectedView === pageType.currentPage && (
          <div className="health-facility-actions">
            {(approvalLayout.requestData.requestFor == approvalConstantData.requestFor.sent && resubmitEnable) && <Button
              onClick={() => { dispatch(setApprovalPageType(approvalConstantData.pageType.edit)) }}
              disabled={(approvalLayout.requestData.requestStatus === STATUS.PENDING || approvalLayout.requestData.requestStatus === STATUS.APPROVED) || approvalLayout.requestData.requestResubmited}
              id="edit-details"
              buttonName={buttonNames.reSubmit}
              colorType={'primary'}
              icon={''}
              iconPosition={''}
            />}
            {approvalLayout.requestData.requestFor == approvalConstantData.requestFor.received && <>
              {rejectEnable && <Button
                onClick={() => { setShowApprovalModal(true); }}
                disabled={roleData == roleType.only_administrator || approvalLayout.requestData.requestStatus === STATUS.REJECTED || approvalLayout.requestData.requestStatus === STATUS.APPROVED || approvalLayout.requestData.requestStatus === STATUS.NO_ACTION}
                id="cancel"
                buttonName={buttonNames.reject}
                colorType={'save'}
                icon={''}
                iconPosition={''}
              />}
              {editApproveEnable && <Button
                onClick={() => { dispatch(setApprovalPageType(approvalConstantData.pageType.edit)) }}
                disabled={roleData == roleType.only_administrator || approvalLayout.requestData.requestStatus === STATUS.REJECTED || approvalLayout.requestData.requestStatus === STATUS.APPROVED || approvalLayout.requestData.requestStatus === STATUS.NO_ACTION}
                id="edit-details"
                buttonName={buttonNames.editApprove}
                colorType={'primary'}
                icon={''}
                iconPosition={''}
              />}
            </>}
          </div>
        )}
      </div>
      <hr />
      <div className="selected-content">
        {renderFacilityDetails()}
      </div>
      {showApprovalModal && <ApprovalModal showModal={showApprovalModal} handleModalClose={() => setShowApprovalModal(false)} handleSubmit={handleReject} headerText='Reason for Rejection' isCommentsRequired={true} />}
    </div>
  );

  function formatLinkedFacility(data: any, type: string) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];

    switch (type) {
      case 'linked-facility':
        return data.map((item: any) => ({
          id: item?.facility_id,
          name: item?.facility_name,
          code: item?.facility_code,
        }));
      case 'village':
        return data.map((item: any) => ({
          id: item?.village_id,
          name: item?.village_name,
          code: item?.village_code,
        }));
      case 'gram_panchayat':
        return data.map((item: any) => ({
          id: item?.gram_panchayat_id,
          name: item?.gram_panchayat_name,
          code: item?.gram_panchayat_code,
        }));
      case 'ward':
        return data.map((item: any) => ({
          id: item?.ward_id,
          name: item?.ward_name,
          code: item?.ward_code,
        }));
      default:
        return [];
    }
  }

  function formatDate(dateString: string): string {
    if (!dateString) return '-';
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  }


  function renderFacilityDetails() {
    const isGrampanchayat = locationDetails?.gram_panchayat?.gram_panchayat_name;

    return (
      <>
            {(approvalLayout.requestData.requestFor == approvalConstantData.requestFor.sent) && <div className="overview overview_user">
              <BadgesComponent
                className="over-badge"
                badgeName="Receiver Comment"
                variant="primary-1"
                badgeType="case5"
              />
              <div className="overview-details">
                <div>
                  <label className="overview-details-label"> Comment </label>
                  <div className="overview-details-value">{approvalLayout?.requestData?.requestComments || '-'}</div>
                </div>
              </div>
            </div>}
        <div className="overview health_facility">
          <BadgesComponent
            className="over-badge"
            badgeName="Facility Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details">
            <div>
              <label className="overview-details-label">
                Health Facility Name
              </label>
              <div className="overview-details-value">
                {facilityDetails?.facility_name ? facilityDetails?.facility_name : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Facility Category</label>
              <div className="overview-details-value">
                {(locationDetails?.category_details && locationDetails?.category_details?.length)
                  ? joinCategoryNames(locationDetails?.category_details)
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Health Facility Type
              </label>
              <div className="overview-details-value">
                {facilityDetails?.facility_type_name ? facilityDetails?.facility_type_name : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Ownership</label>
              <div className="overview-details-value">
                {facilityDetails?.ownership_name ? facilityDetails?.ownership_name : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">HFR ID</label>
              <div className="overview-details-value">
                {facilityDetails?.hfr_id ? facilityDetails?.hfr_id : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Administrative Body
              </label>
              <div className="overview-details-value">
                {facilityDetails?.admin_body_name ? facilityDetails?.admin_body_name : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Central Government Department
              </label>
              <div className="overview-details-value">
                {facilityDetails?.central_govt_dept_name ? facilityDetails?.central_govt_dept_name : '-'}
              </div>
            </div>
          </div>
        </div>

        <div className="overview">
          <BadgesComponent
            className="over-badge"
            badgeName="ABDM Facility Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details">
            <div>
              <label className="overview-details-label">
                Health Facility Type
              </label>
              <div className="overview-details-value">
                {abdmData?.abdm_facility_name ? abdmData?.abdm_facility_name : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Ownership</label>
              <div className="overview-details-value">
                {abdmData?.abdm_ownership ? abdmData?.abdm_ownership : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Facility Name</label>
              <div className="overview-details-value">
                {abdmData?.abdm_facility_name ? abdmData?.abdm_facility_name : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Facility Status</label>
              <div className="overview-details-value">
                {abdmData?.abdm_status ? abdmData?.abdm_status : '-'}
              </div>
            </div>
          </div>
        </div>

        <div className="overview">
          <BadgesComponent
            className="over-badge"
            badgeName="ABDM Location Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details">
            <div>
              <label className="overview-details-label">State</label>
              <div className="overview-details-value">
                {abdmData?.abdm_state_name
                  ? `${abdmData?.abdm_state_name} - ${abdmData?.abdm_state_code}`
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">District Name</label>
              <div className="overview-details-value">
                {abdmData?.abdm_district_name
                  ? `${abdmData?.abdm_district_name} - ${abdmData?.abdm_district_code}`
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Sub District Name
              </label>
              <div className="overview-details-value">
                {abdmData?.abdm_sub_district_name
                  ? `${abdmData?.abdm_sub_district_name} - ${abdmData?.abdm_sub_district_code}`
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Village /City/Town Name
              </label>
              <div className="overview-details-value">
                {abdmData?.abdm_village_city_town_name
                  ? `${abdmData?.abdm_village_city_town_name} - ${abdmData?.abdm_village_city_town_code}`
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Address</label>
              <div className="overview-details-value">
                {abdmData?.abdm_address ? abdmData?.abdm_address : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Latitude</label>
              <div className="overview-details-value">
                {abdmData?.abdm_latitude ? abdmData?.abdm_latitude : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Longitude</label>
              <div className="overview-details-value">
                {abdmData?.abdm_longitude ? abdmData?.abdm_longitude : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Pincode</label>
              <div className="overview-details-value">
                {abdmData?.abdm_pincode ? abdmData?.abdm_pincode : '-'}
              </div>
            </div>
          </div>
        </div>

        <div className="overview">
          <BadgesComponent
            className="over-badge"
            badgeName="Enrollment Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details">
            <div>
              <label className="overview-details-label">Date of Enrollment</label>
              <div className="overview-details-value">
                {facilityDetails?.enrollment_dt
                  ? formatDate(dayjs(facilityDetails?.enrollment_dt).format('YYYY-MM-DD'))
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Effective From Date
              </label>
              <div className="overview-details-value">
                { facilityDetails?.effective_from_dt?(selectedView === pageType.previousPage ?
  
                    dayjs(facilityDetails?.effective_from_dt).format('DD-MM-YYYY')
                  
                  :dayjs(facility[0]?.effective_from_date).format('DD-MM-YYYY')):'-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Status</label>
              <div className="overview-details-value">
                {facilityDetails?.status_name ? facilityDetails?.status_name : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Sanctioned Bed Count
              </label>
              <div className="overview-details-value">
                {facilityDetails?.sanctioned_bed_count ? facilityDetails?.sanctioned_bed_count : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Functional Bed Count
              </label>
              <div className="overview-details-value">
                {facilityDetails?.functional_bed_count ? facilityDetails?.functional_bed_count : '-'}
              </div>
            </div>
          </div>
        </div>

        <div className="overview">
          <BadgesComponent
            className="over-badge"
            badgeName="Hierarchy Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details">
            <div>
              <label className="overview-details-label">State</label>
              <div className="overview-details-value">
                {locationDetails?.state?.state_name
                  ? `${locationDetails?.state?.state_name} - ${locationDetails?.state?.state_code}`
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">District</label>
              <div className="overview-details-value">
                {locationDetails?.district?.district_name
                  ? `${locationDetails?.district?.district_name} - ${locationDetails?.district?.district_code}`
                  : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Rural/Urban</label>
              <div className="overview-details-value rural_urban">
                {locationDetails?.urban_rual?.urban_rural_name ? `${locationDetails?.urban_rual?.urban_rural_name} `
                  : '-'}
              </div>
            </div>
            {locationDetails?.urban_rual?.urban_rural_name !== ruralUrban.rural && locationDetails?.ulb?.ulb_name && (
              <div>
                <label className="overview-details-label">ULB</label>
                <div className="overview-details-value">
                  {`${locationDetails?.ulb?.ulb_name} `}
                </div>
              </div>
            )}
            <div>
              <label className="overview-details-label">Sub District</label>
              <div className="overview-details-value">
                {locationDetails?.sub_district?.sub_district_name
                  ? `${locationDetails?.sub_district?.sub_district_name} - ${locationDetails?.sub_district?.sub_district_code}`
                  : '-'}
              </div>
            </div>
            {locationDetails?.urban_rual?.urban_rural_name !== ruralUrban.urban && locationDetails?.block?.block_name && (
              <div>
                <label className="overview-details-label">Block</label>
                <div className="overview-details-value">
                  {`${locationDetails?.block?.block_name} - ${locationDetails?.block?.block_code}`}
                </div>
              </div>
            )}
            <div>
              <label className="overview-details-label">Health Block</label>
              <div className="overview-details-value">
                {locationDetails?.health_block?.health_block_name ? `${locationDetails?.health_block?.health_block_name} - ${locationDetails?.health_block?.health_block_code}` : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Sub Division</label>
              <div className="overview-details-value">
                {locationDetails?.sub_division?.sub_division_name ? `${locationDetails?.sub_division?.sub_division_name} - ${locationDetails?.sub_division?.sub_division_code}` : '-'}
              </div>
            </div>
            {locationDetails?.urban_rual?.urban_rural_name !== ruralUrban.urban && (
              <div>
                <label className="overview-details-label">
                  {isGrampanchayat ? 'Gram Panchayat / ADC Village' : 'Village'}
                </label>
                <div className="overview-details-value">
                  {isGrampanchayat
                    ? locationDetails?.gram_panchayat?.gram_panchayat_name
                      ? `${locationDetails?.gram_panchayat?.gram_panchayat_name}`
                      : '-'
                    : locationDetails?.village?.village_name
                      ? `${locationDetails?.village?.village_name}`
                      : '-'}
                </div>
              </div>
            )}
            {locationDetails?.urban_rual?.urban_rural_name !== ruralUrban.rural && locationDetails?.ward?.ward_name && (
              <div>
                <label className="overview-details-label">Ward</label>
                <div className="overview-details-value">
                  {`${locationDetails?.ward?.ward_name} - ${locationDetails?.ward?.ward_code}`}
                </div>
              </div>
            )}
            <div>
              <label className="overview-details-label">Parliamentary</label>
              <div className="overview-details-value">
                {locationDetails?.pc?.pac_name ? `${locationDetails?.pc?.pac_name} - ${locationDetails?.pc?.pac_code}` : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">LAC 1</label>
              <div className="overview-details-value">
                {locationDetails?.lac?.lac_name ? `${locationDetails?.lac?.lac_name} - ${locationDetails?.lac?.lac_code}` : '-'}
              </div>
            </div>
          </div>
        </div>

        <div className="overview">
          <BadgesComponent
            className="over-badge"
            badgeName="Location Details"
            variant="primary-1"
            badgeType="case5"
          />
          <div className="overview-details">
            <div>
              <label className="overview-details-label">Address</label>
              <div className="overview-details-value">
                {facilityDetails?.address ? facilityDetails?.address : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Latitude</label>
              <div className="overview-details-value">
                {facilityDetails?.latitude ? facilityDetails?.latitude : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Longitude</label>
              <div className="overview-details-value">
                {facilityDetails?.longitude ? facilityDetails?.longitude : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Pincode</label>
              <div className="overview-details-value">
                {facilityDetails?.pincode ? facilityDetails?.pincode : '-'}
              </div>
            </div>
          </div>
          <div className="form-map-upgrade">
            <FacilityESRIMap
              selectedAddressValue={{ current: { value: facilityDetails?.address } }}
              latitude={facilityDetails?.latitude}
              longitude={facilityDetails?.longitude}
              dtCode={{ dtCode: locationDetails?.district?.district_code }}
              onLocationChange={() => { }}
              onPostalCodeChange={() => { }}
              onformFieldChange={() => { }}
              mapRender={false}
              pageType={page_type.approval_view}
            />
          </div>
          <div className="attributionNotes">
            Powered By <img src={`${config.root ? config.root : ''}/assets/images/NicBharatMaps.png`} alt="NicBharatMaps" style={{ height: 40 }} />
          </div>
        </div>


        <div className="overview">
          <div className="upgrade_coverage">
            <BadgesComponent
              className="over-badge"
              badgeName="Coverage Details"
              variant="primary-1"
              badgeType="case5"
            />
            <div className="overview-details-upgrade">
              <div className="upgrade_coverage_details_page">
                {locationDetails?.urban_rual?.urban_rural_name === ruralUrban.rural && (
                  <div className="coverage_rural_facility_village">
                    <div className="coverage_rural_facility">
                      <CoverageCardViewComponent
                        listItems={formatLinkedFacility(
                          locationDetails?.linked_facility_details,
                          'linked-facility',
                        )}
                        labelforCoverage={'Linked Facilities'}
                      />
                    </div>
                    <div className="coverage_urban_ward">
                      <CoverageCardViewComponent
                        listItems={formatLinkedFacility(
                          locationDetails?.linked_ward,
                          'ward',
                        )}
                        labelforCoverage={'Linked Wards'}
                      />
                    </div>
                    <div className="coverage_rural_village">
                      {isGrampanchayat ? (
                        <CoverageCardViewComponent
                          listItems={formatLinkedFacility(
                            locationDetails?.linked_gram_panchayat,
                            'gram_panchayat',
                          )}
                          labelforCoverage={
                            'Linked Gram Panchayats / ADC Villages'
                          }
                        />
                      ) : (
                        <CoverageCardViewComponent
                          listItems={formatLinkedFacility(
                            locationDetails?.linked_village,
                            'village',
                          )}
                          labelforCoverage={'Linked Villages'}
                        />
                      )}
                    </div>
                  </div>
                )}
                {locationDetails?.urban_rual?.urban_rural_name !== ruralUrban.rural && (
                  <div className="coverage_urban_facility_ward">
                    <div className="coverage_urban_facility">
                      <CoverageCardViewComponent
                        listItems={formatLinkedFacility(
                          locationDetails?.linked_facility_details,
                          'linked-facility',
                        )}
                        labelforCoverage={'Linked Facilities'}
                      />
                    </div>
                    <div className="coverage_urban_ward">
                      <CoverageCardViewComponent
                        listItems={formatLinkedFacility(
                          locationDetails?.linked_ward,
                          'ward',
                        )}
                        labelforCoverage={'Linked Wards'}
                      />
                    </div>
                    <div className="coverage_rural_village">
                      {isGrampanchayat ? (
                        <CoverageCardViewComponent
                          listItems={formatLinkedFacility(
                            locationDetails?.linked_gram_panchayat,
                            'gram_panchayat',
                          )}
                          labelforCoverage={
                            'Linked Gram Panchayats / ADC Villages'
                          }
                        />
                      ) : (
                        <CoverageCardViewComponent
                          listItems={formatLinkedFacility(
                            locationDetails?.linked_village,
                            'village',
                          )}
                          labelforCoverage={'Linked Villages'}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
};

export default HealthFacilityOverview;
